import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SEO from '../components/common/SEO';

export default function DashboardPage() {
  const { t } = useTranslation();
  const { user } = useSelector((s) => s.auth);

  // Admins always use the admin panel, not the guest user dashboard
  if (user?.role === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  const cards = [
    { to: '/learn', icon: '📚', label: t('dashboard.myLearning') },
    { to: '/tips', icon: '💡', label: t('nav.tips') },
    { to: '/stories', icon: '⭐', label: t('nav.stories') },
  ];

  return (
    <>
      <SEO title={t('dashboard.welcome')} />
      <section className="py-12 px-4 max-w-4xl mx-auto">
        <h1 className="section-title mb-2">{t('dashboard.welcome')}, {user?.name}! 👋</h1>
        <p className="text-gray-500 mb-8">{user?.email} · {user?.role}</p>
        <div className="grid sm:grid-cols-3 gap-4">
          {cards.map((c) => (
            <Link key={c.to} to={c.to} className="card text-center hover:border-brand-300 hover:-translate-y-1 transition-all">
              <span className="text-4xl">{c.icon}</span>
              <p className="font-semibold mt-3">{c.label}</p>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
